import { getField, updateField } from "vuex-map-fields";
import db from "@/firebase/firebaseInit";

const state = { 
    totalSymptoms:[],
    totalPreventions:[]
};

const actions = { 
    async fetchTotalSymptoms({ commit }, payload) {  
        await db.collection(`/symptoms/${payload}/all_symptoms`).get().then(
            (snapshot) => {
                var totalSymptoms = [];
                snapshot.forEach(doc => {
                    totalSymptoms.push(doc.data());
                }); 
                commit("updateField", {
                    path: "totalSymptoms",
                    value: totalSymptoms,
                })    
           }); 
    },
    async fetchTotalPreventions({ commit }, payload) {  
        await db.collection(`/prevents/${payload}/all_prevents`).get().then(
            (snapshot) => {
                var totalPreventions = [];
                snapshot.forEach(doc => {
                    totalPreventions.push(doc.data());
                }); 
                commit("updateField", {
                    path: "totalPreventions",
                    value: totalPreventions,
                })    
           }); 
    },

    async addSymptoms({ }, { payload }) {
      
        await db.collection(`/symptoms/${payload.lang}/all_symptoms`).add({
            caption: payload.symptom.caption,
            description: payload.symptom.description,
            image: payload.symptom.image,
            title: payload.symptom.title 
        });

    },

    async addPrevents({ }, { payload }) { 
       
        await db.collection(`/prevents/${payload.lang}/all_prevents`).add({
            caption: payload.prevent.caption,
            description: payload.prevent.description,
            image: payload.prevent.image,
            title: payload.prevent.title 
        });

    },
};

const mutations = {
    updateField,
};

const getters = {
    getField,
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
